import { useRequest } from 'features/request/useRequest';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { gqlWorkOrderVersionActsKC2Version } from '../workOrderVersionQueries';

export const useWorkOrderVersionActs = ({ versionId }: { versionId?: number }) => {
    const dispatch = useDispatch();

    const actsVariables = useMemo(
        () => ({
            workOrderVersionId: versionId,
        }),
        [versionId],
    );

    const [actsKC2VersionResultData, , , request] = useRequest({
        requestId: 'workOrderVersionActsKC2Version',
        query: gqlWorkOrderVersionActsKC2Version,
        variables: actsVariables,
        withEffect: Boolean(versionId),
    });

    const acts = useMemo(
        () => actsKC2VersionResultData?.uerWorkOrderVersionActsKC2Version ?? [],
        [actsKC2VersionResultData?.uerWorkOrderVersionActsKC2Version],
    );

    const refreshActs = useCallback(() => {
        dispatch(request(actsVariables));
    }, [actsVariables, dispatch, request]);

    return {
        acts,
        refreshActs,
    };
};
